import React from 'react';
import { ListContent, styled } from '@teko/ds-mobile';
import {
  HomepageAlternativeOutlined,
  ClockAlternativeOutlined,
  SearchOutlined,
  MoreProductOutlined,
  HomePageOutlined,
  TimeForwardOutlined,
  NewSearchOutlined,
  NewMoreProductOutlined,
} from '@teko/ds-icon';
import { useRouter } from 'next/router';
import { useCategories, useTenantConfig } from 'contexts';

const DropdownMenuWrapper = styled.div`
  box-shadow: 0 0 4px rgba(0, 0, 0, 0.2);
  border-radius: 4px;
`;

export const NavBarDropdownMenu: React.FC<{
  isShowingCategories?: boolean;
  onClickHomeItem?: () => void;
}> = ({ isShowingCategories = false, onClickHomeItem }) => {
  const router = useRouter();
  const { setShowingCategory } = useCategories();
  const { displayNewLayoutForProductDetailSGC } = useTenantConfig();

  return (
    <DropdownMenuWrapper>
      <ListContent
        padding="s8"
        label={
          displayNewLayoutForProductDetailSGC
            ? 'Đi tới Trang chủ'
            : 'Quay lại trang chủ'
        }
        icon={
          displayNewLayoutForProductDetailSGC ? (
            <HomePageOutlined size={16} />
          ) : (
            <HomepageAlternativeOutlined />
          )
        }
        onClick={() => {
          router.push('/').then(() => window.scrollTo(0, 0));
          onClickHomeItem?.();
        }}
      />
      <ListContent
        padding="s8"
        label="Sản phẩm vừa xem"
        icon={
          displayNewLayoutForProductDetailSGC ? (
            <TimeForwardOutlined size={16} />
          ) : (
            <ClockAlternativeOutlined />
          )
        }
        onClick={() => {
          router.push('/san-pham-vua-xem').then(() => window.scrollTo(0, 0));
        }}
      />
      <ListContent
        padding="s8"
        label="Tìm kiếm"
        icon={
          displayNewLayoutForProductDetailSGC ? (
            <NewSearchOutlined size={16} />
          ) : (
            <SearchOutlined />
          )
        }
        onClick={() => {
          router.push('/search').then(() => window.scrollTo(0, 0));
        }}
      />
      {isShowingCategories ? (
        <ListContent
          padding="s8"
          label="Danh mục sản phẩm"
          icon={
            displayNewLayoutForProductDetailSGC ? (
              <NewMoreProductOutlined size={16} />
            ) : (
              <MoreProductOutlined />
            )
          }
          onClick={() => {
            setShowingCategory(true);
          }}
        />
      ) : null}
    </DropdownMenuWrapper>
  );
};
